<template>
    <div> 
    <v-card >
        <v-layout pt-3 >
          <v-flex xs3>
            <div 
              class="caption"
              style="margin-left:1rem;margin-top:-0.6rem"
             
            ><v-icon small style="margin-right:1rem">date_range</v-icon>{{event.timestamp}}</div>
          </v-flex>
          <v-flex>
            <v-layout>
              <v-flex >
                <v-chip :color="event.color" dark style="margin-top:-0.5rem">
                <v-icon small style="margin-right:1rem">memory</v-icon>
                {{event.id}}
                </v-chip>
              </v-flex>
              <v-flex>
                <v-layout row wrap :key="index">
                  <v-flex xs9>
                   <v-layout row wrap> 
                      <v-flex xs12 class="caption">{{event.message}}</v-flex>
                      <v-flex xs12 class="caption font-weight-bold">{{event.measure}} ({{event.type}}) </v-flex>
                   </v-layout>
                  </v-flex>
                  <v-flex xs3>
                    <v-icon v-if="event.severity==0" color="green">check_circle</v-icon>
                    <v-icon v-else-if="event.severity==1" color="amber">warning</v-icon>
                    <v-icon v-else-if="event.severity==2" color="red">error</v-icon>
                    <v-icon v-else color="primary">info</v-icon>
                  </v-flex>
                </v-layout >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
  </v-card>
    </div>
</template>

<script>

export default {
  name: 'EventView',
  props: {
    event: Object,
    // {
    //    source
    //    timestamp
    //    severity: [info, normal, warning, alert]
    //    domain
    //    description
    //    color
    // }

  },
  data(){
    return{
      colors: [
        '#f67019',
        '#f53794',
        '#537bc4',
        '#acc236',
        '#166a8f',
        '#00a950',
        '#58595b',
        '#8549ba',
        '#4dc9f6'
      ],
      
    }
  },
  
  watch:{
    event:{
      handler(){
      },
      deep:true
    }
  },

  mounted(){
  },

  methods:{
      computeSeverityColor(event){
          switch(event.severity){
            case "alert":
                return "red"
            case "warning":
                return "amber"
            case "normal":
                return "green"
            default:
                return "blue"
          }
      }
  }
}

</script>

<style >


</style>
